import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_MULTISTEP_REACTION_DIALOG } from './constants';

export const rsState = (state) => state && state.get(REDUCER_KEY_RS);
export const multiStepReactionDialog = (state) => rsState(state).get(REDUCER_KEY_MULTISTEP_REACTION_DIALOG);
export const isLoading = (state) => multiStepReactionDialog(state).isLoading;
export const response = (state) => multiStepReactionDialog(state).response;
export const routeLayout = (state) => (response(state) || {}).routeLayout;
export const addProjectIsLoading = (state) => multiStepReactionDialog(state).addProjectIsLoading;
